import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '@/components/Logo';
import { useAuth } from '@/context/AuthContext';

const Splash = () => {
  const navigate = useNavigate();
  const { currentUser, userCity } = useAuth();

  useEffect(() => {
    const timer = setTimeout(() => {
      // Check if user is authenticated and has selected a city
      if (currentUser) {
        if (userCity) {
          navigate('/home');
        } else {
          navigate('/city-selection');
        }
      } else {
        navigate('/login');
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate, currentUser, userCity]);

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #43A047 0%, #66BB6A 25%, #9CCC65 50%, #CDDC39 75%, #FDD835 100%)'
      }}
      data-testid="splash-screen"
    >
      {/* Animated background circles */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
      <div className="absolute bottom-32 right-16 w-48 h-48 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-1/2 right-1/4 w-24 h-24 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>

      {/* Logo */}
      <div className="z-10 mb-8 animate-fade-in">
        <Logo size="large" />
      </div>

      {/* Tagline */}
      <p className="text-white text-xl font-medium mb-12 z-10 animate-fade-in" style={{ animationDelay: '0.3s' }}>
        Find what's local. Go smart.
      </p>

      {/* Loading spinner */}
      <div className="z-10 animate-fade-in" style={{ animationDelay: '0.6s' }}>
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default Splash;
